import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged, signInAnonymously } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

// Firebase configuration for v3-creative-engine
// NOTE: Firebase web API keys are safe to commit — they identify the project
// but are not secret credentials. Access is controlled by Firestore/Storage
// Security Rules and Firebase Authentication settings.
// See: https://firebase.google.com/docs/projects/api-keys
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAyX-ghq4W2KGAk6CCjKVSWc6sKQBDMZiQ",
  authDomain: "template-stamper-staging.firebaseapp.com",
  projectId: "template-stamper-staging",
  storageBucket: "template-stamper-staging.firebasestorage.app",
  messagingSenderId: "572470520040",
  appId: "1:572470520040:web:6dd7b0c0f2e6751bcd415d",
  measurementId: "G-WZCJW4L5EZ"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

let authBootstrapPromise: Promise<void> | null = null;

export function ensureFirebaseAuth(): Promise<void> {
  if (auth.currentUser) {
    return Promise.resolve();
  }

  if (!authBootstrapPromise) {
    authBootstrapPromise = new Promise<void>((resolve, reject) => {
      const unsubscribe = onAuthStateChanged(auth, async (user) => {
        if (user) {
          unsubscribe();
          resolve();
          return;
        }

        try {
          await signInAnonymously(auth);
        } catch (error) {
          unsubscribe();
          authBootstrapPromise = null;
          reject(error);
        }
      });
    });
  }

  return authBootstrapPromise;
}

// Connect to local emulators in development
if (import.meta.env.DEV) {
  connectFirestoreEmulator(db, 'localhost', 8082);
  connectStorageEmulator(storage, 'localhost', 9199);
  connectFunctionsEmulator(functions, 'localhost', 5001);
}
